import { FiPhoneCall } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { CLINIC } from "../../data/clinic";
import "./FloatingContact.css";

export default function FloatingContact() {
  if (!CLINIC.phone) return null;

  const telHref = `tel:${CLINIC.phone.replace(/\s+/g, "")}`;
  const waHref = `https://wa.me/${CLINIC.phone.replace(/\D/g, "")}`;

  return (
    <div className="floating-contact">
      <a href={waHref} className="floating-contact__btn whatsapp" aria-label="Chat on WhatsApp" target="_blank" rel="noreferrer">
        <FaWhatsapp />
      </a>
      <a href={telHref} className="floating-contact__btn call" aria-label="Call the clinic">
        <FiPhoneCall />
      </a>
    </div>
  );
}
